import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Orbit, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Toaster } from "../components/ui/sonner";

export default function Login() {
  const nav = useNavigate();
  const [email, setEmail] = useState("patrick@repliantarc.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", {
        email: email.trim().toLowerCase(),
        password: password,
      });
      if (data.user.role !== "admin") {
        toast.error("This is the admin sign-in. Use your branded portal link instead.");
        setLoading(false);
        return;
      }
      localStorage.setItem("ra_token", data.token);
      localStorage.setItem("ra_user", JSON.stringify(data.user));
      toast.success("Welcome back");
      nav("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="login-page"
      className="min-h-screen bg-[#0a0a0b] flex items-center justify-center relative overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(ellipse_at_top,_rgba(255,176,0,0.08),transparent_60%)]" />
      <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-[#FFB000]/5 blur-3xl pointer-events-none" />

      <div className="w-full max-w-[440px] px-6 relative">
        <div className="flex items-center gap-3 mb-10">
          <div className="relative">
            <Orbit className="w-10 h-10 text-[#FFB000]" strokeWidth={1.5} />
            <div className="absolute inset-0 blur-xl bg-[#FFB000]/30 rounded-full" />
          </div>
          <div>
            <div className="text-white text-xl font-medium tracking-tight leading-none">
              Repliant Arc
            </div>
            <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-white/40 mt-1.5">
              Command Center
            </div>
          </div>
        </div>

        <div className="mb-8">
          <h1 className="text-3xl font-medium tracking-tight text-white mb-2">
            Sign in
          </h1>
          <p className="text-sm text-white/50">
            Access your outbound AI calling platform.
          </p>
        </div>

        <form onSubmit={submit} className="space-y-4" data-testid="login-form">
          <div>
            <label className="text-xs font-medium text-white/50 uppercase tracking-[0.1em] mb-2 block">
              Email
            </label>
            <input
              data-testid="login-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full bg-[#121214] border border-white/10 rounded-md text-white text-sm px-3.5 py-2.5 placeholder:text-white/30 focus:outline-none focus:ring-1 focus:ring-[#FFB000] focus:border-[#FFB000] transition-all"
              placeholder="you@repliantarc.com"
            />
          </div>
          <div>
            <label className="text-xs font-medium text-white/50 uppercase tracking-[0.1em] mb-2 block">
              Password
            </label>
            <input
              data-testid="login-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full bg-[#121214] border border-white/10 rounded-md text-white text-sm px-3.5 py-2.5 placeholder:text-white/30 focus:outline-none focus:ring-1 focus:ring-[#FFB000] focus:border-[#FFB000] transition-all"
              placeholder="••••••••••"
            />
          </div>
          <button
            data-testid="login-submit-btn"
            type="submit"
            disabled={loading}
            className="w-full bg-[#FFB000] hover:bg-[#FFC133] text-black font-medium text-sm px-4 py-2.5 rounded-md transition-colors shadow-[0_0_24px_rgba(255,176,0,0.18)] disabled:opacity-60 flex items-center justify-center gap-2"
          >
            {loading && <Loader2 className="w-4 h-4 animate-spin" />}
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <div className="arc-divider my-8" />
        <p className="text-[11px] font-mono uppercase tracking-[0.15em] text-white/30 text-center">
          v0.1 · Phase 1 · Outbound Engine
        </p>
      </div>
      <Toaster theme="dark" richColors position="top-right" />
    </div>
  );
}
